import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    // 天満ニア公式WEBサイト, written in English as the official site name.
    name: 'AMAMA NIA Official Website',
    description: "ゲームと音楽の物語を旅する観測者、天満ニア（AMAMA NIA）の公式サイト。相棒のMAHOとともに電子世界をめぐるマホニア観測局の記録、配信、楽曲、グッズ、活動実績をお届けします。",
    url: getOrigin(),
    // Activity links shown as icons in the header, the mobile menu and the footer.
    links: {
        youtube: 'https://www.youtube.com/@amamania',
        x: 'https://x.com/amamania',
        fanbox: 'https://amamania.fanbox.cc/',
        tunecore: 'https://www.tunecore.co.jp/artists/Amama_Nia'
    }
}
